import { Injectable, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { filter } from 'rxjs/operators';
import { LoaderService } from '../../loader.service';

@Injectable({
  providedIn: 'root'
})
export class RouteLoaderHandlerService {
  private router = inject(Router);
  private loaderService$ = inject(LoaderService);
  private modalService = inject(NgbModal);

  // Note: This service is a singleton (providedIn: 'root') and lives for the
  // entire app lifetime. The router subscription intentionally has no cleanup
  // because it should remain active as long as the app is running.
  public startListening(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      // eslint-disable-next-line rxjs-x/no-ignored-subscription
      .subscribe((_event: NavigationStart) => {
        if (this.modalService.hasOpenModals()) {
          this.modalService.dismissAll();
        }

        this.loaderService$.hide();
      });
  }
}
